/** Cloudflare RealtimeKit preset for livestream hosts (webinar presenter). */
export const RTK_HOST_PRESET = "webinar_presenter";

export const RTK_HIGH_QUALITY_AUDIO = {
  enableHighBitrate: true,
  enableStereo: true,
  echoCancellation: false,
  noiseSupression: false,
  autoGainControl: false
} as const;